module.exports = __webpack_public_path__ + "static/media/Symptoms.bfbb74d1.png";